var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3341_83789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#E9D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4503 6.4499L11.8253 3.0874C11.2941 2.6999 10.6628 2.49365 10.0003 2.49365C9.3378 2.49365 8.7128 2.6999 8.1753 3.0874L3.5503 6.4499C2.4628 7.24365 2.00655 8.6374 2.4253 9.91865L4.19405 15.3562C4.6128 16.6374 5.79405 17.4999 7.14405 17.4999H12.8628C14.2128 17.4999 15.3941 16.6374 15.8128 15.3562L17.5816 9.91865C18.0003 8.6374 17.5441 7.24365 16.4566 6.4499H16.4503Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14396 16.9812C6.02521 16.9812 5.03771 16.2624 4.68771 15.1999L2.91896 9.7624C2.57521 8.69365 2.95021 7.5374 3.85646 6.88115L8.48146 3.51865C8.92521 3.19365 9.45021 3.0249 10.0002 3.0249C10.5502 3.0249 11.0752 3.19365 11.519 3.51865L16.144 6.88115C17.0502 7.5374 17.4252 8.6999 17.0815 9.7624L15.3127 15.1999C14.969 16.2687 13.9815 16.9812 12.8565 16.9812H7.13771H7.14396Z",
    fill: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 3.2812C10.4821 3.2812 10.9571 3.4312 11.3634 3.72495L15.9884 7.08745C16.8009 7.67495 17.1384 8.72495 16.8321 9.6812L15.0634 15.1187C14.7509 16.075 13.8634 16.7187 12.8571 16.7187H7.13839C6.13214 16.7187 5.24464 16.0687 4.93214 15.1187L3.16339 9.6812C2.85089 8.72495 3.19464 7.6812 4.00714 7.08745L8.63214 3.72495C9.03839 3.4312 9.51964 3.2812 9.99464 3.2812M9.99464 2.76245C9.38839 2.76245 8.81339 2.94995 8.32589 3.3062L3.70089 6.6687C2.70089 7.3937 2.28839 8.6687 2.66964 9.8437L4.43839 15.2812C4.81964 16.4562 5.90714 17.2437 7.13839 17.2437H12.8571C14.0884 17.2437 15.1759 16.4562 15.5571 15.2812L17.3259 9.8437C17.7071 8.6687 17.2946 7.3937 16.2946 6.6687L11.6696 3.3062C11.1821 2.94995 10.6009 2.76245 10.0009 2.76245H9.99464Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.0134 8.1812L8.6384 4.8187C9.4509 4.2312 10.5509 4.2312 11.3634 4.8187L15.9884 8.1812C16.4446 8.51245 16.7509 8.98745 16.8759 9.5062C17.0946 8.59995 16.7509 7.63745 15.9884 7.0812L11.3634 3.7187C10.5509 3.1312 9.4509 3.1312 8.6384 3.7187L4.0134 7.0812C3.2509 7.63745 2.9009 8.59995 3.1259 9.5062C3.2509 8.98745 3.55715 8.51245 4.0134 8.1812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3341_83789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceBubble);
export default __webpack_public_path__ + "static/media/ExperienceBubble.9c1bcdb646f2970af9a91d3d1bf7cfe0.svg";
export { ForwardRef as ReactComponent };